import s from '../Accordion.module.scss';

const FooterLogo = ({ url, logoBnW, logoColor, width, height, alt }) => (
  <div className={s.imgFooter}>
    <a href={url} target='_blank'>
      <img
        onMouseOver={(e) => (e.currentTarget.src = logoColor)}
        onMouseOut={(e) => (e.currentTarget.src = logoBnW)}
        src={logoBnW}
        width={width}
        height={height}
        border='0'
        loading='lazy'
        alt={alt}
      />
    </a>
  </div>
);

export default FooterLogo;
